 {
  "titles": {
    "overview": "Overzicht",
    "declineReason": "Reden voor afwijzing",
    "renewalRequest": "Verlenging",
    "extraCostsSpecification": "Extra kosten specificatie",
    "repayments": "Aflossingen"
  },
  "fields": {
    "labels": {
      "status": "Status",
      "referenceNumber": "Referentienummer",
      "amount": "Leningbedrag",
      "interestRate": "Tarief per 30 dagen",
      "interestAmount": "Financieringskosten",
      "paymentAmount": "Uitbetaald bedrag",
      "toBePaid": "Uit te betalen",
      "durationInDays": "Looptijd",
      "startDate": "Startdatum",
      "collectionDate": "Incassodatum",
      "previousLoan": "Vorige lening",
      "renewalCostsSpecification": {
        "interestAmount": "Financieringskosten",
        "interestAmountIncrease": "Verschil tarief",
        "penaltyAmount": "Achterstallige rente",
        "administrationCosts": "Administratiekosten",
        "defaultingAdministrationCosts": "Herinneringen",
        "renewalAdministrationCosts": "Verlenging",
        "partialManualTransferAdministrationCosts": "Handmatige overboekingen",
        "totalAmountToReceive": "Totaal te ontvangen"
      },
      "extraCostsSpecification": {
        "defaultingSince": "In gebreke sinds",
        "defaultingDays": "Aantal dagen in gebreke",
        "defaultingAmount": "Bedrag in gebreke",
        "penaltyRate": "Boetetarief",
        "penaltyAmount": "Achterstallige rente",
        "administrationCosts": "Administratiekosten",
        "defaultingAdministrationCosts": "Herinneringen",
        "renewalAdministrationCosts": "Verlenging",
        "partialManualTransferAdministrationCosts": "Handmatige overboekingen",
        "totalAmountToReceive": "Totaal terug te betalen"
      },
      "legacyExtraPrincipalCosts": "Extra financieringskosten"
    }
  },
  "messages": {
    "collectionDateUpcoming": "Over {time} wordt deze lening geïncasseerd",
    "collectionDateToday": "Vandaag wordt deze lening geïncasseerd",
    "hasPendingRenewalRequest": "Verzoek tot verlengen ontvangen",
    "renewalUpcoming": "Lening wordt automatisch verlengd per incassodatum",
    "hasApprovedRenewalRequest": "Verzoek tot verlengen geaccepteerd, betaalinstructies verzonden naar de klant",
    "hasRequestedEarlyRepayment": "Verzoek tot eerder terugbetalen ontvangen.",
    "collectionPartiallyFailed": "Incasso's zijn deels mislukt",
    "collectionFullyFailed": "Incasso's zijn mislukt",
    "hasPausedExtraCost": "Vanwege de migratie zijn de extra kosten voor deze lening gepauzeerd.",
    "expiredRenewalRequest": "Verlengverzoek is verlopen.",
    "rejectedRenewalRequest": "Verlengverzoek is afgewezen.",
    "cancelledRenewalRequest": "Verlengverzoek is geannuleerd.",
    "renewedRenewalRequest": "Verlengverzoek is uitgevoerd met lening",
    "awaitingRenewalPayment": "In afwachting van betaling",
    "renewalRequestReason": "Reden verlengverzoek: {reason}",
    "pausedExtraCostNoticeTitle": "In-gebreke berekening is gepauzeerd",
    "pausedExtraCostNoticeDescription": "Door onze recente overstap naar een nieuw systeem wijken de kosten bij deze lening in gebreke tijdelijk af. Dit heeft te maken met specifieke afspraken uit het verleden die momenteel administratief worden rechtgetrokken. Zodra deze historie is gecorrigeerd, wordt de vastgestelde, standaard berekeningsmethode gehanteerd.",
    "directDebitsVisibleOnStart": "De incasso’s worden zichtbaar zodra de lening van start gaat"
  },
  "repayments": {
    "type": {
      "DirectDebit": "Incasso",
      "Transfer": "Overboeking",
      "Renewal": "Afgelost met"
    },
    "status": {
      "Scheduled": "Ingepland",
      "Successful": "Betaald",
      "Failed": "Mislukt",
      "Cancelled": "Geannuleerd",
      "Processing": "Betaling in behandeling"
    }
  }
}
